<div *ngIf="data" class="widget-container">
  <div class="header">
    {{ data.title }}
  </div>
  <div class="loading-content" *ngIf="!dateLabel">
    <lib-loading></lib-loading>
  </div>
  <div *ngIf="dateLabel" class="clock-container">
    <div class="clock-content">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 26C5.8201 26 0 20.1799 0 13C0 5.8201 5.8201 0 13 0C20.1799 0 26 5.8201 26 13C26 20.1799 20.1799 26 13 26ZM13 23.4C15.7583 23.4 18.4035 22.3043 20.3539 20.3539C22.3043 18.4035 23.4 15.7583 23.4 13C23.4 10.2417 22.3043 7.59647 20.3539 5.64609C18.4035 3.69571 15.7583 2.6 13 2.6C10.2417 2.6 7.59647 3.69571 5.64609 5.64609C3.69571 7.59647 2.6 10.2417 2.6 13C2.6 15.7583 3.69571 18.4035 5.64609 20.3539C7.59647 22.3043 10.2417 23.4 13 23.4ZM14.3 13H19.5V15.6H11.7V6.5H14.3V13Z" fill="#EB194B"/>
      </svg>
      <span class="clock-hour-minute">{{ timeHM }}</span>
      <span class="clock-seconds">{{ timeS }}</span>
      <span class="clock-date">{{ dateLabel }}</span>
    </div>
  </div>
</div>
